import './Text.css';
import table1 from '../media/imagen/Table.svg';

const TeorSoc = () => {
  return (
    <div className="textinputteor">
      <h1>Социометрия</h1>
      <p className="Wtext">
        Социометрия — это социально-психологический экспериментальный метод опроса, направленный на 
        количественное измерение взаимосвязей и анализ структуры межличностных и межгрупповых 
        отношений в малых социальных группах путем фиксации связей симпатии-антипатии в ситуациях 
        выбора среди членов группы. Автором методики социометрии является Джекоб Морено.
      </p>
      
      <p className="Wtext">
        Социометрия бывает 2 типов: параметрическая и непараметрическая.
      </p>

      <h2>Параметрическая социометрия</h2>
      <p>
        Имеет ограничение количества выборов каждого участников. Величина ограничения - лимит выборов. 
        Введением этой величины можно стандартизировать внешние условия выборов в группах разной численности.
      </p>
      
      <h6>Достоинства параметрической процедуры:</h6>
      <p>
        Это повышает надёжность полученных данных, позволяет стандартизировать условия выбора в группах 
        различной численности, появляется возможность сравнивать взаимоотношения в разных группах.
      </p>
      
      <h6>Недостатки параметрической процедуры:</h6>
      <p>
        Не раскрывает всего многообразия взаимоотношений в группе; социометрическая структура группы в 
        результате такого подхода будет отражать лишь наиболее типичные, «избранные» коммуникации. 
        Введение ограничения не позволяет судить об разнообразии эмоциональных взаимоотношений членов группы.
      </p>

      <h2>Непараметрическая социометрия</h2>
      <p>
        Не имеет ограничения количества выборов, то есть участник имеет возможность выбрать каждого 
        участника группы, кроме самого себя.
      </p>
      
      <h6>Достоинства непараметрической процедуры:</h6>
      <p>
        Это позволяет выявить разнообразие эмоциональных взаимоотношений каждого члена группы, виден срез 
        всего многообразия связей в группе.
      </p>
      
      <h6>Недостатки непараметрической процедуры:</h6>
      <p>
        Существует большая вероятность получения случайного выбора из-за аморфной системы отношений 
        выбирающего человека с окружающими или же из-за ложных ответов, с целью дать «безопасные» 
        социально желаемые ответы.
      </p>

      <p>
        Социометрия — это методика предназначенная для малых коллективов и команд, поэтому число 
        участников в группах должно быть ограничено. Обычно используется следующая схема определения 
        размера группы и ограничений в зависимости от размера:
      </p>
      <div className='imgcenter'> 
      <img src={table1} alt="Таблица ограничений" />
      </div>
      <h2>Инструменты социометрии</h2>
      <p>
        Социометрия является крайне гибкой процедурой, которая изменяется и приспосабливается к любой 
        групповой особенности. Социометрическая процедура должна быть выстроена и преобразована в 
        соответствии с потенциальными возможностями членов группы на момент проведения исследования, 
        чтобы участники могли сформировать доверительное отношение к опросу и максимально открыто и 
        точно могли выразить свое отношение и уровень привязанности к членам группы. Если не модифицировать 
        социометрический опрос под особенности группы, то результаты могут предоставить ограниченное 
        или искаженное представление о ней. Поэтому тщательно подойти к выбору социометрических критериев, 
        которые вы будете использовать в своем опросе.
      </p>
      
      <p className="Wtext">
        Социометрический критерий — это вопрос или несколько вопросов о сфере совместной деятельности 
        участников опроса, в рамках которого респондентом будет совершаться выбор или отклонение наиболее 
        соответствующего члена или членов группы. Социометрический критерий представляет собой реальную 
        или заданную область или ситуацию, которая соотносится с целями исследования и реальна для 
        участников исследования.
      </p>

      <h2>Социометрические критерии и вопросы «Динамики»</h2>
      
      <h3>Критерий «лидерский потенциал»</h3>
      <p>Кто в большей степени подходит на роль лидера среди вашего коллектива?</p>
      <p>Кого из вашего коллектива вы не видите в роли лидера коллектива?</p>
      
      <h3>Критерий «лидерство»</h3>
      <p>Кого бы вы выбрали лидером вашего коллектива?</p>
      <p>Кого бы вы не выбрали лидером вашего коллектива?</p>
      
      <h3>Критерий «прогностический критерий»</h3>
      <p>Как вы думаете, кто из ваших коллег выбрал бы вас лидером?</p>
      <p>Как вы думаете, кто из ваших коллег не выбрал бы вас лидером?</p>
      
      <h3>Критерий «неформальные отношения»</h3>
      <p>Кого из ваших коллег вы бы пригласили на день рождения/поход в кино/новоселье/прочее совместное времяпрепровождение?</p>
      <p>Кого из ваших коллег вы бы не пригласили на день рождения/поход в кино/новоселье/прочее совместное времяпрепровождение?</p>
      
      <h3>Критерий «Формальные отношения»</h3>
      <p>С кем из ваших коллег вы бы более охотно поехали в продолжительную командировку/посетили тренинг?</p>
      <p>С кем из ваших коллег вы бы менее охотно поехали в продолжительную командировку/посетили тренинг?</p>
      
      <h3>Критерий «Интеллектуальный авторитет»</h3>
      <p>Кого из своих коллег вы бы попросили о помощи в рабочих задачах в случае необходимости, возникновения трудностей?</p>
      <p>Кого из своих коллег вы бы не попросили о помощи в рабочих задачах в случае необходимости, возникновения трудностей?</p>
      
      <h3>Критерий «Авторитет»</h3>
      <p>Чьему мнению из ваших коллег вы больше всего прислушиваетесь?</p>
      <p>Чьему мнению из ваших коллег вы меньше всего прислушиваетесь/безразличны?</p>
      
      <h3>Критерий «Коммуникация»</h3>
      <p>С кем из ваших коллег вы предпочитаете общаться больше всего?</p>
      <p>С кем из ваших коллег вы предпочитаете общаться меньше всего?</p>
      
      <h3>Критерий «Эмоциональная близость»</h3>
      <p>С кем из коллег вы в первую очередь готовы поделиться своими переживаниями, кому бы рассказали о случившейся в вашей жизни трудной ситуации?</p>
      <p>С кем из коллег вы в последнюю очередь готовы поделиться своими переживаниями, кому бы рассказали о случившейся в вашей жизни трудной ситуации?</p>
      
      <h3>Критерий «Сплоченность»</h3>
      <p>В случае ухода с места работы с кем бы вы продолжили общаться?</p>
      <p>В случае ухода с места работы с кем бы вы не продолжили общаться?</p>
      
      <h3>Критерий «Конфликтность»</h3>
      <p>Кто реже всего является зачинщиком или участником конфликтов?</p>
      <p>Кто чаще всего является зачинщиком или участником конфликтов?</p>

      <h2>Результаты</h2>
      <p>
        В отчете вы получите полное описание группы, групповые показатели сплоченности, эмоциональной 
        экспансивности, интеграции и их интерпретацию. А также индивидуальные социометрические статусы 
        членов группы по которым можно выделить состояние членов коллектива.
      </p>

      <h2>Социометрический статус</h2>
      <p>
        Социометрический статус — это положение личности в системе межличностных отношений, которое 
        определяется числом выборов со стороны других членов группы, получаемых каждым отдельным членом 
        группы. Положительные и отрицательные социометрические статусы существенно влияют на 
        эмоциональное состояние и способность людей адаптироваться в социальной среде.
      </p>
      
      <p>Общий статус в группе можно определить следующим образом:</p>
      
      <div className="status-table">
        <table>
          <thead>
            <tr>
              <th>Социометрический статус</th>
              <th>Положительный статус оцениваемого</th>
              <th>Отрицательный статус оцениваемого</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Положительный</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>Отрицательный</td>
              <td>-</td>
              <td>+</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <h3>Положительный статус</h3>
      <p>
        Это член группы с наиболее привлекательной личностью для остальных членов группы или получивший 
        в большей степени положительные выборы или вовсе не получивший или в минимальном количестве число 
        отвержений. Это востребованный или популярный в группе человек, который разделяет общие с группой 
        интересы и ценности, является эмоционально комфортным для коммуникации и работы. Обычно его 
        действия и высказывания получают одобрение со стороны других членов группы.
      </p>
      
      <h3>Отрицательный статус</h3>
      <p>
        Это член группы получивший минимальное число положительных выборов, при этом имеющий большое число 
        отвержений от остальных членов группы или не имеющий положительных выборов вовсе. Чаще всего это 
        человек чье мнение не совпадает с мнением группы, его мировоззрение и социальные привычки вызывают 
        негативную реакцию со стороны других членов группы. Такой человек предпочитает и дальше занимать 
        данную позицию, так как без стороннего вмешательства или собственных изменений сложно привыкнуть 
        к нормам группы, которые уже имеют негативную реакцию.
      </p>
      
      <h3>Нейтральный статус</h3>
      <p>
        Это член группы у которого нет ни положительных, ни отрицательных выборов или член коллектива, 
        которого одинаково принимают или не принимают разные члены коллектива. Он не вызывает у других 
        членов группы ни положительных, ни отрицательных эмоций. Он может находиться в пограничном 
        состоянии и при возможности привыкнуть к коллективу или определенной микрогруппе, а может 
        наоборот совсем отдалиться от коллектива и отвергнуться группой. Этот человек требует работы по 
        включению его в группу для того, чтобы его статус не перешел в отрицательное значение.
      </p>

      <h2>Социограмма</h2>
      <p>
        Социограмма — это графическое изображение получаемых ответов респондентов, отражающих структуру 
        и иерархию респондентов в группе. Социограмма позволяет наглядно описать структуру общения в группе.
      </p>
      <p>
        Социограмма — это диаграмма, состоящая из четырех секторов, внутри которых размещаются фигуры с 
        условными обозначениями соответствующих им членов группы и обозначаются выборы каждого из членов 
        по определенному социометрическому критерию. Размещение членов группы внутри секторов определяется 
        суммой баллов, полученных участником. Участники располагаются на расстоянии от центра в соответствии 
        с количеством баллов, что отражает социальную дистанцию между членами группы.
      </p>
      <p>
        В центральном круге располагаются лица с наивысшим социометрическим статусом - «звезды», они 
        имеют наибольшее количество выборов и малое количество отвержений. Во втором секторе размещаются 
        участники с высоким количеством выборов и небольшим количеством отвержений — высокостатусные 
        участники. В третьем круге — члены группы со статусом имеющие малое количество как выборов, 
        так и отвержений, то есть низкостатусные участники. В последнем четвертом секторе располагаются 
        «изолированные» — члены группы у которых нет выборов и отклонений, и «отвергаемые» — члены группы 
        с наибольшим количеством отвержений соответственно. Внутри секторов при необходимости также 
        вводится градация размещения: те участники, у которых большее число выборов располагаются ближе 
        к внутренней границе круга и/или в его центре, а участники с наименьшим числом выборов — ближе 
        к внешней границе круга.
      </p>

      <h2>Классификация участников</h2>
      
      <h3>Социометрические звезды</h3>
      <p>
        Члены группы имеющие максимальное количество положительных выборов при небольшом количестве 
        отрицательных выборов (от 80% до 100% положительных выборов и 20% и менее отрицательных выборов). 
        Это люди, к которым обращены симпатии большинства или, по крайней мере, многих членов группы.
      </p>
      
      <h3>Высокостатусные</h3>
      <p>
        (от 70% до 80% положительных выборов и 30% и менее отрицательных выборов). Это люди, которые 
        положительно воспринимаются группой или принимаются большей ее частью.
      </p>
      
      <h3>Среднестатусные</h3>
      <p>
        (от 60% до 70% положительных выборов и 40% и менее отрицательных выборов).
      </p>
      
      <h3>Низкостатусные</h3>
      <p>
        Члены группы (от 50% до 60% положительных выборов и 50% и менее отрицательных выборов), 
        определяемые по числу положительных выборов и не имеющие большого числа отрицательных выборов. 
        Такие люди занимают место в системе взаимоотношений группы и имеют эмоциональные связи в группе, 
        но либо часть группы (часто другая микрогруппа) эмоционально не принимает его, либо характер 
        членов его взаимодействия не полностью совпадают с групповыми. Есть группы в которых нет 
        социометрических звезд, а есть только высоко-, средне-, низкостатусные.
      </p>
      
      <h3>Изолированные</h3>
      <p>
        Субъекты, у которых отсутствуют любые выборы как положительные, так и отрицательные. Позиция 
        изолированного человека в группе — одна из наиболее неблагоприятных. Такие члены группы не 
        принимаются никем, поэтому их очень сложно внедрить в коллектив. Часто изолированность может 
        быть вызвана незавершенной или неудачной адаптацией после приема на работу, безынициативностью 
        или отрешенностью «изолированного». Изолированные члены коллектива имеют высокий риск выгорания 
        или стресса, низкой лояльности к компании или высокий риск ухода, поэтому такие лица должны 
        стать объектом пристального внимания со стороны аналогов/кадровых специалистов/руководителя. 
        Изолированных членов коллектива следует включать в групповую деятельность, мотивировать к 
        взаимодействию и построению связей с группой.
      </p>
      
      <h3>Отверженные</h3>
      <p>
        Это такие члены группы которые имеют большое количество отрицательных выборов и малое количество 
        предпочтений (10-30% положительных и 70-90% отрицательных выборов). Эти люди принимаются лишь 
        небольшой частью, часто только своей микрогруппой и имеют мало взаимодействий и эмоциональных 
        взаимосвязей с другими членами коллектива.
      </p>
      
      <h3>Пренебрегаемые или аутсайдеры</h3>
      <p>
        Члены группы не имеющие ни одного положительного выбора при наличии отрицательных. Группа высокого 
        риска, это люди, которые не смогли интегрироваться в группу, не разделяют общих ценностей с группой 
        или не смогли установить эмоциональную связь с членами группы. Они наиболее всего подвержены травле 
        и риску ухода.
      </p>
    </div>
  );
};

export default TeorSoc;